module.exports = __webpack_public_path__ + "img/ipad.293075db.png";